<template>
    <Page :show-title="showTitle" :title="title">
        <Card>
            <div class="condition-line" v-if="showSearch">
                <Container rightWidth="200px">
                    <template v-slot:right>
                        <div class="block">
                            <slot name="new"></slot>
                        </div>
                    </template>
                    <slot name="search"></slot>
                    <div class="block">
                        <el-button type="primary" size="mini" @click="searchData"> 查询 </el-button>
                    </div>
                </Container>
            </div>
            <div class="content-line-padding">
                <el-table size="mini" :data="dataList">
                    <slot></slot>
                </el-table>
            </div>
            <div class="ly-pagerline" v-if="showPager">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="count"
                ></el-pagination>
            </div>
            <slot name="other"></slot>
        </Card>
    </Page>
</template>

<script>
import Page from "./Page.vue";
export default {
    name: "ListPage",
    components: { Page },
    data() {
        return {
            pageIndex: 1,
            pageSize: 20,
            count: 0,
            dataList: [],
        };
    },
    props: {
        title: { type: String, default: "" },
        showTitle: {
            type: Boolean,
            default: true,
        },
        api: { type: String, default: "" },
        searchParam: {
            type: Object,
            default() {
                return {};
            },
        },
        showPager: { type: Boolean, default: true },
        showSearch: { type: Boolean, default: true },
    },
    created() {},
    mounted() {
        this.searchData();
    },
    methods: {
        searchData() {
            let p = Object.assign({}, this.searchParam);
            if (this.showPager) {
                p.PageIndex = this.pageIndex;
                p.PageSize = this.pageSize;
            }
            this.$ajax.post(this.api, p).then((result) => {
                this.dataList = result.Data;
                if (this.showPager) {
                    this.count = result.Count;
                }
                this.$emit("complete", this.dataList);
            });
        },
        handleSizeChange() {
            this.pageIndex = 1;
            this.searchData();
        },
        handleCurrentChange(e) {
            this.pageIndex = e;
            this.searchData();
        },
    },
};
</script>
